﻿<template>
  <PmwParagraph size="paragraph-80" weight="light">
    {{ formatedDates }}
  </PmwParagraph>
</template>

<script>
import { format, isAfter } from 'date-fns'
import setDefaultOptions from 'date-fns/setDefaultOptions'
import { ptBR } from 'date-fns/locale'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'DateRangeText',

  components: {
    PmwParagraph
  },

  props: {
    /**
     * Datas de início e fim
     * dates.start
     * dates.end
     */
    dates: {
      type: Object
    }
  },

  computed: {
    formatedDates() {
      const startDate = new Date(this.dates.start)
      const endDate = this.dates.end ? new Date(this.dates.end) : null

      if (endDate && isAfter(endDate, startDate)) {
        const start = format(startDate, 'dd MMM yyyy')
        const end = format(endDate, 'dd MMM yyyy')
        return `${start} - ${end}`
      }

      return format(startDate, 'dd MMM yyyy')
    }
  },

  created() {
    setDefaultOptions({ locale: ptBR })
  }
}
</script>
